var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact contact-email",class:("contact-email-" + _vm.style_class)},[_c('mail-icon',{staticClass:"custom-class",attrs:{"size":"1x"}}),_c('span',[_vm._v("info.shop@gmail.com")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }